import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import store from "@/domain/vuex/store";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('routeStore/set_actualRoute',to.path.substring(1))

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(to.path =='/perfil' && window.location.search.startsWith('?sessionId') ) {
      store.dispatch('authenticateStore/SESSION_LOGIN', window.location.search.slice(window.location.search.indexOf('=',1) + 1))

    } else if( !!store.state.authenticateStore.token ) {
        next()
        return
      }

    next('/login')
  } else {
    if( (to.path =='/login') && !!store.state.authenticateStore.token ) {
      next('/inicio')

    } else next()
    
  }
})

export default router